<template>
	<div class="like">
		<div class="section">
			<div class="list" v-for="item in likeList" @click="goDetail(item.id)">
				<img :src="item.image | handleUrl" alt="">
				<div class="foot-tips">
					<div>
						<div class="title slaksj">{{item.title}}</div>
						<div class="zujinhsae">
							<span>
								<span v-if="item.category_id == 1">租金</span>
								<span v-else>价格:</span>
								<span class="money">¥{{item.price}}</span><span v-if="item.category_id == 1" class="yueleja">/月<span class="qingdong">起</span>
								</span>
							</span>
							<!-- <span v-if="item.category_id == 1">起/年</span> -->
							<span>
								<van-icon name="shopping-cart-o" size="0.9rem" color="#fff" /></span>


						</div>


						<!-- <div  class="gongqi-xing">
							<span v-if="item.goods_work == 7">工期7-10天</span>
							<span v-if="item.goods_work == 15">工期15-20天</span>
							<span v-if="item.goods_work == 30">工期30-35天</span>
							<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
						 </div> -->
						<!-- <div class="gongqi-xing">
							<span v-if="props.value.goods_work == 7">工期7-10天</span>
							<span v-if="props.value.goods_work == 15">工期15-20天</span>
							<span v-if="props.value.goods_work == 30">工期30-35天</span>
							<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="props.value.hot_num" readonly />
						 </div> -->

					</div>
				</div>
				<div class="vangrid-bottom">
					<div class="gongqi-xing">
						<span v-if="item.goods_work == 7">工期7-10天</span>
						<span v-if="item.goods_work == 15">工期15-20天</span>
						<span v-if="item.goods_work == 30">工期30-40天</span>
						<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="item.hot_num" readonly />
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//猜您喜欢
				likeList: []
			}
		},
		created() {
			var that = this;
			//精品推荐
			if (sessionStorage.getItem("couwc-cnxh") == null) {
				that.$axios.post(baseUrl + '/mobile/Base/goodsRecommend', {
					cat_id: 4,
					limit: 10
				}).then(function(res) {
					if (res.data.code == 2) {
						sessionStorage.setItem("couwc-cnxh", JSON.stringify(res.data.data));
						that.likeList = JSON.parse(sessionStorage.getItem("couwc-cnxh"));
					}
				}).catch(function(err) {
					console.log(err);
				});
			} else {
				that.likeList = JSON.parse(sessionStorage.getItem("couwc-cnxh"));
			}
		},
		methods: {
			goDetail(id) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import 'like.css';

	.yueleja {
		color: red;
	}

	.slaksj {
		padding-top: 0.5rem;
	}

	.gongqi-xing {
		display: flex;
		justify-content: space-between;
		padding: 0 0.3rem;
		padding-bottom: 0.5rem;
	}

	.gongqi-xing .van-rate {
		position: relative;
		top: 0.15rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/like/like.vue